// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor-toolbar[data-v-9c6e33ac]{position:relative;display:flex}.editor-toolbar .bx--btn[data-v-9c6e33ac]{height:50px;width:50px}#submenu--align[data-v-9c6e33ac]{position:absolute;top:50px;right:0;height:48px;background:#161616;color:orange;z-index:1}", ""]);
// Exports
module.exports = exports;
